import { EvaChart } from "constants/charts.enums";
import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { translateBoxPlotResponseTooltipOptions } from "./boxPlot";
import { translateCAGRResponseTooltipOptions } from "./cagr";
import { translateCrossPlotTooltipOptions } from "./crossPlot";
import { translateCumTimeResponseTooltipOptions } from "./cumTime";
import { translateDeclineRateResponseTooltipOptions } from "./declineRate";
import { translateMaterialBalanceTooltipOptions } from "./materialBalanceTime";
import { translateMosaicResponseTooltipOptions } from "./mosaic";
import { translateProbitResponseTooltipOptions } from "./probit";
import { translateRateCumResponseTooltipOptions } from "./rateCum";
import { translateRateDateResponseTooltipOptions } from "./rateDate";
import { translateRateTimeResponseTooltipOptions } from "./rateTime";
import { translateRecoveryPVIResponseTooltipOptions } from "./recoveryPVI";
import { translateRecoveryTimeResponseTooltipOptions } from "./recoveryTime";
import { translateStackedBarResponseTooltipOptions } from "./stackedBar";
import { translateStackedBarHorizontalResponseTooltipOptions } from "./stackedBarHorizontal";
import { translateTotalRateCumResponseTooltipOptions } from "./totalRateCum";
import { translateTotalRateDateResponseTooltipOptions } from "./totalRateDate";
import { translateTrendDateResponseTooltipOptions } from "./trendDate";
import { translateWellContributionResponseTooltipOptions } from "./wellContribution";

export const TOOLTIP_CREATORS_MAP = {
  [EvaChart.RateCum]: translateRateCumResponseTooltipOptions,
  [EvaChart.RecoveryPVI]: translateRecoveryPVIResponseTooltipOptions,
  [EvaChart.RecoveryTime]: translateRecoveryTimeResponseTooltipOptions,
  [EvaChart.CrossPlot]: translateCrossPlotTooltipOptions,
  [EvaChart.CumTime]: translateCumTimeResponseTooltipOptions,
  [EvaChart.RateTime]: translateRateTimeResponseTooltipOptions,
  [EvaChart.RateDate]: translateRateDateResponseTooltipOptions,
  [EvaChart.TotalRateDate]: translateTotalRateDateResponseTooltipOptions,
  [EvaChart.TotalRateCum]: translateTotalRateCumResponseTooltipOptions,
  [EvaChart.DeclineRate]: translateDeclineRateResponseTooltipOptions,
  [EvaChart.CAGR]: translateCAGRResponseTooltipOptions,
  [EvaChart.TrendDate]: translateTrendDateResponseTooltipOptions,
  [EvaChart.Mosaic]: translateMosaicResponseTooltipOptions,
  [EvaChart.StackedBar]: translateStackedBarResponseTooltipOptions,
  [EvaChart.StackedBarHorizontal]: translateStackedBarHorizontalResponseTooltipOptions,
  [EvaChart.BoxPlot]: translateBoxPlotResponseTooltipOptions,
  [EvaChart.Probit]: translateProbitResponseTooltipOptions,
  [EvaChart.Pie]: () => ({}),
  [EvaChart.MaterialBalanceTime]: translateMaterialBalanceTooltipOptions,
  // Injector Total shares Trend Date's per-focus-group line/time-axis shape, so its tooltip
  // formatting is delegated to the same implementation.
  [EvaChart.InjectorTotal]: translateTrendDateResponseTooltipOptions,

  // midstream charts
  [EvaChart.RateDateMidstream]: translateRateTimeResponseTooltipOptions,
  [EvaChart.TotalRateDateMidstream]: translateTotalRateDateResponseTooltipOptions,
  [EvaChart.CrossPlotMidstream]: translateCrossPlotTooltipOptions,
  [EvaChart.WellContribution]: translateWellContributionResponseTooltipOptions,
  [EvaChart.MosaicMidstream]: translateMosaicResponseTooltipOptions,
  [EvaChart.StackedBarMidstream]: translateStackedBarResponseTooltipOptions,
  [EvaChart.TrendDateMidstream]: translateTrendDateResponseTooltipOptions,
  [EvaChart.BoxPlotMidstream]: translateBoxPlotResponseTooltipOptions
};

export function translateTooltipOptions({
  type,
  states
}: {
  type: EvaChart;
  states: Partial<EvaChartStates>;
}): TooltipOption {
  const tooltipOptions = TOOLTIP_CREATORS_MAP[type];
  if (!tooltipOptions) {
    throw new Error(`Unknown chart type: ${type} to create tooltip options`);
  }
  return tooltipOptions(states);
}
